import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { auth, database, ref, get } from './db/firebase';
import { notification } from 'antd';

const ProtectedRoute = ({ allowedRoles, facilityId, children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [api] = notification.useNotification();

  const openNotification = (type, message) => {
    api[type]({
      message,
      placement: 'bottomRight',
      style: {
        background: '#14141465',
        color: '#fff',
        border: '1px solid #40a9ff',
        borderRadius: '8px',
        boxShadow: '0 3px 8px rgba(255, 255, 255, 0.2)',
      },
    });
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        // Fetch user role from Realtime Database
        const userSnapshot = await get(ref(database, `users`));
        if (userSnapshot.exists()) {
          const facilities = userSnapshot.val();
          let foundRole = null;
          if (facilities.me && facilities.me.email === currentUser.email) {
            foundRole = facilities.me.role;
          } else {
            for (const fid in facilities) {
              if (fid === 'me') continue;
              const users = facilities[fid];
              for (const uid in users) {
                if (users[uid].email === currentUser.email) {
                  foundRole = users[uid].role;
                  break;
                }
              }
              if (foundRole) break;
            }
          }
          setUserRole(foundRole);
          console.log('ProtectedRoute - User:', currentUser.email, 'Role:', foundRole, 'Allowed Roles:', allowedRoles);
          openNotification('info', `Entering protected page. User: ${currentUser.email}, Role: ${foundRole || 'N/A'}, Allowed Roles: ${allowedRoles.join(', ')}`);
        }
      } else {
        setUser(null);
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowedRoles]);

  if (loading) {
    return <div>Loading...</div>; // Optional loading state
  }

  if (!user) {
    console.log('ProtectedRoute - No user, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  if (user && allowedRoles && !allowedRoles.includes(userRole)) {
    console.log('ProtectedRoute - Role mismatch, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  // Validate facilityId if provided - but allow superadmins to access any facility
  if (facilityId && userRole !== 'superadmin') {
    const pathFacilityId = window.location.pathname.split('/')[1];
    if (!pathFacilityId) {
      console.log('ProtectedRoute - Invalid facilityId, redirecting to /login');
      return <Navigate to="/login" replace />;
    }
    
    // For non-superadmins, verify they belong to the facility they're trying to access
    if (userRole === 'admin' || userRole === 'cashier') {
      // Additional validation could be added here to ensure the user belongs to this facility
      // For now, we rely on the role-based access control
    }
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;